import _ from 'lodash'
import { useMemo } from 'react'
import { TextLink } from '@components/atoms'
import { Typography } from '@mui/material'
import { EventEntity } from '@services/nomos_api/entities/event'

type Props = {
  event: EventEntity
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any
  index: number
}

export function MonitoredPropositionScheduled({
  event,
  data,
  index,
}: Props): JSX.Element | null {
  if (!event) return null

  const { savedPropositions } = event

  const isMonitored = useMemo(() => {
    return (savedPropositions || []).some((item) =>
      [
        _.get(data, `${index}.openDataPropositionId`),
        _.get(data, `${index}.relatedOpenDataPropositionId`),
      ].includes(item.propositionOpenDataId || 'unknown')
    )
  }, [savedPropositions, data, index])

  const propositionId = _.get(data, `${index}.propositionId`)

  const color = useMemo(() => {
    if (isMonitored) {
      return '#ED6D47'
    }
    if (propositionId) {
      return '#2970FF'
    }
    return '#606162'
  }, [isMonitored, propositionId])

  const title = _.get(data, `${index}.title`)

  return propositionId ? (
    <TextLink
      target="_blank"
      text={title}
      underline="none"
      color={color}
      href={`/propositions/${propositionId}`}
    />
  ) : (
    <Typography variant="$font-text-link" color={color}>
      {title}
    </Typography>
  )
}
